// Aviso de promo 2x1 — Ramo De Limonium x 25 Tallos (todas las variantes).
// El 2x1 lo aplica el descuento automatico "2x1 Limonium" de Shopify en el checkout:
// el cliente agrega 2 unidades y la segunda queda en $0. Este script solo muestra el aviso.
// Vigencia: hasta el 31 de agosto de 2026.

(function () {
  'use strict';

  var NOTICE_ID = 'promo-2x1-notice';
  var PRODUCT_HANDLE = 'ramo-de-limonium-x-25-tallos';
  var TEXTO = '🌼 Promo 2×1: agrega 2 ramos de Limonium al carrito y el segundo te sale gratis';

  function esProductoEnPromo(section) {
    var form = section.querySelector('product-form-component[data-product-url]');
    if (!form) return false;
    var url = form.getAttribute('data-product-url') || '';
    return url.split('?')[0].split('/').pop() === PRODUCT_HANDLE;
  }

  // El aviso va pegado al boton "Comprar ahora" (payment button de Shopify).
  // Si ese boton no existe (producto sin checkout acelerado), cae al contenedor
  // de botones y luego al form.
  function findAnchor(section) {
    return (
      section.querySelector('.shopify-payment-button') ||
      section.querySelector('.accelerated-checkout-block') ||
      section.querySelector('.product-form-buttons') ||
      section.querySelector('[data-type="add-to-cart-form"]')
    );
  }

  var reposicionando = false;

  function syncNotice(section) {
    if (!section.querySelector('[data-type="add-to-cart-form"]')) return;

    var existing = section.querySelector('#' + NOTICE_ID);
    if (!esProductoEnPromo(section)) {
      if (existing) existing.remove();
      return;
    }

    var anchor = findAnchor(section);
    if (!anchor) return;

    var notice = existing;
    if (!notice) {
      notice = document.createElement('div');
      notice.id = NOTICE_ID;
      notice.style.cssText = 'margin-top:0.5rem;padding:0.5rem 0.75rem;background:#fef9e7;border:1px solid #c8a020;border-radius:4px;font-size:0.85rem;color:#7a5e00';
      notice.textContent = TEXTO;
    }

    // insertAdjacentElement mueve el nodo si ya existe: reubica sin duplicar.
    if (anchor.nextElementSibling !== notice) {
      reposicionando = true;
      anchor.insertAdjacentElement('afterend', notice);
      reposicionando = false;
    }

    observarAnclaje(anchor);
  }

  // widget-envio.js se reubica de forma asincrona y se mete entre el boton y el
  // aviso. Vigilamos el contenedor del boton para devolver el aviso a su lugar.
  var observados = [];

  function observarAnclaje(anchor) {
    var parent = anchor.parentNode;
    if (!parent || observados.indexOf(parent) !== -1) return;
    observados.push(parent);
    new MutationObserver(function () {
      if (!reposicionando) syncAll();
    }).observe(parent, { childList: true });
  }

  function syncAll() {
    document.querySelectorAll('.shopify-section').forEach(syncNotice);
  }

  document.addEventListener('variant:selected', syncAll);
  document.addEventListener('DOMContentLoaded', syncAll);
  syncAll();
})();
